import { useEffect, useState } from "react";
import { Check } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { useStart } from "./useStart";

const Card = ({ id, name, price, note, features, badge, cta, onClick }) => (
  <div data-testid={`pricing-plan-${id}`} className={`panel p-6 flex flex-col relative ${badge ? "ring-1 ring-primary/50" : ""}`}>
    {badge && <span className="absolute -top-3 left-6 text-[11px] uppercase tracking-wider font-bold rounded-full px-3 py-1 brand-gradient text-white">{badge}</span>}
    <h3 className="text-lg font-semibold">{name}</h3>
    <div className="mt-3 mb-5"><span className="font-display text-3xl font-extrabold">{price}</span> <span className="text-xs text-muted-foreground">{note}</span></div>
    <ul className="space-y-2.5 text-sm flex-1">
      {features.map((f) => (<li key={f} className="flex gap-2"><Check className="h-4 w-4 text-primary mt-0.5 shrink-0" />{f}</li>))}
    </ul>
    <button data-testid={`pricing-cta-${id}`} onClick={onClick} className="mt-6 h-11 rounded-full font-semibold brand-gradient text-white hover:opacity-90 transition-opacity">{cta}</button>
  </div>
);

export const Pricing = () => {
  const start = useStart();
  const navigate = useNavigate();
  const { user } = useAuth();
  const [cat, setCat] = useState(null);
  useEffect(() => { api.get("/plans/catalog").then((r) => setCat(r.data)).catch(() => setCat({ trial: { total: 3 }, plans: [] })); }, []);
  const go = () => navigate(user ? "/upgrade" : "/login");
  return (
    <section id="pricing" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div className="max-w-2xl mb-12 space-y-3">
        <div className="eyebrow">Pricing</div>
        <h2 className="text-3xl sm:text-4xl font-bold tracking-tight">Try {cat?.trial.total ?? 3} free. Then pick your plan.</h2>
        <p className="text-sm text-muted-foreground">One-time payments, no auto-renew. India pays in ₹ (UPI, cards, netbanking); international prices in USD.</p>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-5">
        <Card id="free" name="Free Trial" price="Free" note="one time" cta="Start free trial" onClick={() => start()}
          features={[`${cat?.trial.total ?? 3} AI generations`, "Every feature unlocked", "No card needed"]} />
        {cat?.plans.map((p) => (
          <Card key={p.plan_id} id={p.plan_id} name={p.name} price={`₹${p.price_inr.toLocaleString("en-IN")}`} note={`· $${p.price_usd} intl`}
            badge={p.badge} cta="Subscribe" onClick={go}
            features={[`${p.credits.toLocaleString()} AI generations`, `Valid ${p.days} days`, "Screenshot, Scan, Photo Rizz & 100+ languages"]} />
        ))}
      </div>
    </section>
  );
};
